import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'clayco-controls'; 

const FormValidationMessage = ({ submitAttempted }) => {
    const {t} = useTranslation();

    const { errors } = useFormState();
    const [hasErrors, setHasErrors] = useState();

    useEffect(() => {
        setHasErrors(errors != null && Object.keys(errors).length > 0);
    }, [errors])

    return(
        <>
        {submitAttempted && hasErrors && 
            <div className='mt-2' style={{ color: '#dc3545', fontSize: '14px' }}>
                    {t(`ResolveErrors`)}
            </div>
        }
        </>
    )
}

export default FormValidationMessage;